"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorTableSearch = exports.default = void 0;
var search_component_1 = require("./search.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(search_component_1).default; } });
Object.defineProperty(exports, "ProductEditorTableSearch", { enumerable: true, get: function () { return search_component_1.ProductEditorTableSearch; } });
